"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var use_config_1 = require("./use-config");
Object.defineProperty(exports, "useConfig", { enumerable: true, get: function () { return use_config_1.useConfig; } });
var with_config_1 = require("./with-config");
Object.defineProperty(exports, "withConfig", { enumerable: true, get: function () { return with_config_1.withConfig; } });
//# sourceMappingURL=index.js.map